import { Stack, Text } from '@shopify/polaris';
import { fetching_remaining_products } from "../../../../../../../../../assets/index.js";

const FetchRemainingProducts = ({ totalToFetch, totalFetched }) => {
    return (
        <Stack vertical alignment="center" spacing="loose">
            <img
                src={fetching_remaining_products}
                alt="Adding products in your action"
                width="325px"
                height="195px"
                style={{
                    objectFit: "cover",
                    objectPosition: "center"
                }}
            />
            <Text as="h2" variant="headingLg" fontWeight="bold">
                Adding products in your action...
            </Text>
            <Text as="p" variant="bodyMd">
                Hold on while we're adding all the products you selected. This may take a while depending on the number of products.
            </Text>
            <Text as="p" variant="bodyMd">
                {totalFetched}/{totalToFetch} products added
            </Text>
        </Stack>
    );
};

export default FetchRemainingProducts;
